import { memo }                     from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EnumType }                 from 'json-to-graphql-query';
import VerificationCodeFields       from './Fields';
import API                          from 'api';

function ConnectedVerificationCodeFields(props) {
  const emailCode = useSelector(state => state.emailCode);
  const dispatch = useDispatch();

  // --------------------------------------------------------------------

  const getVerificationCode = (email, scope, captcha, type) => {
    const commonInput = {
      scope: new EnumType(scope),
      captcha
    };

    return dispatch(API.mutations.sendEmailVerificationCode({
      input: { email, ...commonInput }
    }));
  };

  // --------------------------------------------------------------------

  const reset = () => {
    dispatch(API.queries.emailCode.reset());
  };

  // --------------------------------------------------------------------

  return (
    <VerificationCodeFields
      emailCode={emailCode}
      getCode={getVerificationCode}
      reset={reset}
      {...props}
    />
  )
};

export default memo(ConnectedVerificationCodeFields);